import React, { useEffect, useState } from "react";
import CommonTitle from "../../components/CommonTitle";
import classesImg from "../../assets/icons/classes.webp";
import { MdCategory } from "react-icons/md";
import ModalStructure from "../../components/ModalStructure";
import ProductClassForm from "./ProductClassForm";
import { IS_LOCAL_ENV } from "../../App";
import InDevelopment from "../InDevelopment";
import { getProductClasses } from "../../services/productClass";
import LoadingPage from "../../components/LoadingPage";
import ProductClassCard from "../../components/ProductClasses/ProductClassCard";
import EmptyData from "../EmptyData";

const ProductClasses = () => {
  const [loading, setLoading] = useState(true);
  const [showModalClass, setShowModalClass] = useState(false);
  const [classes, setClasses] = useState([]);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        const { docs } = await getProductClasses();
        setClasses(docs);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        IS_LOCAL_ENV && console.error(err);
      }
    };
    fetchClasses();
  }, []);

  const loadToParent = (newObj, prevId) => {
    let temp = [...classes];
    if (!prevId) {
      temp.push(newObj);
      setClasses(temp);
    } else {
      const prevIndex = temp.findIndex((obj) => obj.id == prevId);
      if (prevIndex == -1) return;
      temp[prevIndex] = newObj;
      setClasses(temp);
    }
  };

  // if (!IS_LOCAL_ENV) return <InDevelopment />;
  // else
  return (
    <div className="w-full h-full flex flex-col">
      <CommonTitle
        img={classesImg}
        title="Clasificación de Productos"
        text="Visualiza y administra cada clase de productos disponible en el e-commerce."
      >
        <button
          className={` w-fit bg-accent-green text-base m-1 rounded-full py-4 px-6 text-white hover:bg-dark-green transition-all duration-100 font-bold font-poppins `}
          onClick={() => setShowModalClass(true)}
        >
          <div className="flex flex-row items-center">
            <span className="text-nowrap">Añadir clases</span>
            <MdCategory />
          </div>
        </button>
        {showModalClass && (
          <ModalStructure
            customMaxW={"max-w-[550px]"}
            handleCloseModal={() => setShowModalClass(false)}
          >
            <ProductClassForm
              loadToParent={loadToParent}
              handleClose={() => setShowModalClass(false)}
            />
          </ModalStructure>
        )}
      </CommonTitle>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="flex w-full h-full justify-center">
          <div className="flex max-w-[1280px] w-full flex-wrap justify-center gap-4 p-4">
            {classes.length == 0 && <EmptyData />}
            {classes.map((_class, i) => {
              return (
                <ProductClassCard
                  info={_class}
                  key={i}
                  loadToParent={loadToParent}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductClasses;
